<template>
    <div>
        <div v-if="Object.keys(archives).length > 0">
            <div class="row mx-auto mt-2">
                <div class="col-md-5 mx-auto mb-4" v-if="archives.file.length>0">
                    <v-carousel :continuous="true"
                                cycle
                                :show-arrows="archives.file.length > 1"
                                hide-delimiter-background
                                delimiter-icon="mdi-minus"
                                height="200"
                    >
                        <v-carousel-item
                                v-for="(image, i) in archives.file"
                                :key="i"
                                :src="imageFiles(image)"
                        >
                        </v-carousel-item>
                    </v-carousel>
                </div>
                <div class="col-md-5 mx-auto mb-4" v-if="archives.brandLogo.length>0">
                    <v-carousel :continuous="true"
                                cycle
                                :show-arrows="archives.brandLogo.length > 1"
                                hide-delimiter-background
                                delimiter-icon="mdi-minus"
                                height="200"
                    >
                        <v-carousel-item
                                v-for="(image, i) in archives.brandLogo"
                                :key="i"
                                :src="imageFiles(image)"
                        >
                        </v-carousel-item>
                    </v-carousel>
                </div>
            </div>
            <div class="col-md-12 row pb-10 pt-2">
                <div class="col-md text-right">
                    <div class="row mx-auto text-right px-0 mt-5">
                        <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                       style="color: darkblue">نام مجموعه :</span>
                            {{ archives.organizationName }}
                        </p>
                        <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                       style="color: darkblue">نام برند :</span>
                            {{ archives.brandName }}
                        </p>
                        <p v-if="archives.brandSlogan" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                   style="color: darkblue">شعاربرند :</span>
                            {{ archives.brandSlogan }}
                        </p>
                        <p class="col-md-4 py-1"><span class="font-weight-bolder"
                                                       style="color: darkblue">شعاربرند در لوگو استفاده بشود؟ :</span>
                            {{ archives.slogan ? 'بله' : 'خیر' }}
                        </p>
                        <p v-if="archives.orderType" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                 style="color: darkblue">نوع سفارش :</span>
                            {{ orderType[archives.orderType] }}
                        </p>
                        <p v-if="archives.printCount" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">تعداد چاپ :</span>
                            {{ archives.printCount|currency|persianNum }} عدد
                        </p>
                        <p v-if="archives.logoLanguage" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">زبان طراحی :</span>
                            {{ language[archives.logoLanguage] }}
                        </p>
                        <p v-if="archives.simpleness" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">سبک طراحی :</span>
                            {{ sabks[archives.simpleness] }}
                        </p>
                        <p v-if="archives.complexity" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">نوع طراحی :</span>
                            {{ complexitive[archives.complexity] }}
                        </p>
                        <p v-if="archives.deliveryTime" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">تاریخ تحویل :</span>
                            {{ jalalian(archives.deliveryTime) }}
                        </p>
                        <p v-if="archives.size" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                            style="color: darkblue">سایز پاکت نامه:</span>
                            {{ archives.size.toString() }}
                        </p>
                        <p v-if="archives.pocketOrientation" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                         style="color: darkblue">نوع پاکت نامه:</span>
                            {{ archives.pocketOrientation === 'vertical' ? 'عمودی' : 'افقی' }}
                        </p>
                        <p v-if="archives.pocketText" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">متن پاکت نامه:</span>
                            <span v-html="archives.pocketText"></span>
                        </p>
                        <p v-if="archives.material.letter" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                         style="color: darkblue">جنس پاکت نامه :</span>
                            {{ letterMaterial[archives.material.letter] }}
                        </p>
                        <p v-if="archives.orientation" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                   style="color: darkblue">جهت سربرگ:</span>
                            {{ archives.orientation === 'vertical' ? 'عمودی' : 'افقی' }}
                        </p>
                        <p v-if="archives.size" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                            style="color: darkblue">سایز سربرگ:</span>
                            {{ archives.size.toString() }}
                        </p>
                        <div v-if="archives.headerTexts!== null" class="col-md-4 text-right">
                            <p><span class="font-weight-bolder"
                                     style="color: darkblue">متون ومندرجات روی سربرگ : </span>
                            <p class="font-weight-bold py-0 col-md pr-3"
                               v-for="(line) in archives.headerTexts.split('\n')"
                               :key="line" v-html="line">
                            </p>
                        </div>
                        <p v-if="archives.folderType" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">نوع پوشه:</span>
                            {{ folder[archives.folderType] }}
                        </p>
                        <p v-if="archives.folderText" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                  style="color: darkblue">متن پوشه:</span>
                            <span v-html="archives.folderText"></span>
                        </p>
                        <p v-if="archives.material.folder" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                       style="color: darkblue">جنس پوشه :</span>
                            {{ folderMaterial[archives.material.folder] }}
                        </p>
                        <p v-if="archives.noteBookType" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">نوع دفترچه یادداشت :</span>
                            {{ noteType[archives.noteBookType] }}
                        </p>
                        <p v-if="archives.noteBookSize" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">سایز دفترچه یادداشت :</span>
                            {{ archives.noteBookSize }}
                        </p>
                        <p v-if="archives.noteBookSide" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">جهت بازشدن دفترچه یادداشت :</span>
                            {{ directions[archives.noteBookSide] }}
                        </p>
                        <p v-if="archives.material.noteBook" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                         style="color: darkblue">جنس دفتریادداشت :</span>
                            {{ noteMaterial[archives.material.noteBook] }}
                        </p>
إ
                        <p v-if="archives.noteBookText" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                    style="color: darkblue">توضیحات دفترچه یادداشت :</span>
                            <span v-html="archives.noteBookText"></span>
                        </p>
                        <!--                        <p class="col-md-4 py-1"><span class="font-weight-bolder"-->
                        <!--                                                                             style="color: darkblue">نوع کارت ویزیت :</span>-->
                        <!--                            {{ archives.sides === 'twoSide' ? 'دورو' : 'یک رو' }}-->
                        <!--                        </p>-->
                        <p v-if="archives.diagram" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                               style="color: darkblue">شکل هندسی کارت ویزیت :</span>
                            {{ diagram[archives.diagram] }}
                        </p>
                        <p v-if="archives.material.visiCard" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                       style="color: darkblue">جنس کارت ویزیت :</span>
                            {{ cardMaterial[archives.material.visiCard] }}
                        </p>
                        <p v-if="archives.frontVisitText" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                      style="color: darkblue">متن روی کارت ویزیت :</span>
                            <span v-html="archives.frontVisitText"></span>
                        </p>
                        <p v-if="archives.backVisitText" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                     style="color: darkblue">متن پشت کارت ویزیت :</span>
                            <span v-html="archives.backVisitText"></span>
                        </p>


                        <p v-if="archives.color" class="col-md-4 py-1 pt-2"><span
                                class="font-weight-bolder"
                                style="color: darkblue">رنگ ها : </span>
                            <span class="font-weight-bold py-0">{{
                                    archives.color.toString()
                                }}</span>
                        </p>
                        <br>
                        <p v-if="archives.businessDescription" class="col-md-4 py-1"><span class="font-weight-bolder"
                                                                                           style="color: darkblue">توضیحات کسب وکار :</span>
                            {{ archives.businessDescription }}
                        </p>
                        <div v-if="archives.headerTexts!== null" class="col-md-12 text-right">
                            <p><span class="font-weight-bolder"
                                     style="color: darkblue">متون ومندرجات سربرگ : </span>
                            <p class="font-weight-bold py-0 col-md pr-3"
                               v-for="(line) in archives.headerTexts.split('\n')"
                               :key="line" v-html="line">
                            </p>
                        </div>
                        <div v-if="archives.description!== null" class="col-md-12 text-right">
                            <p><span class="font-weight-bolder"
                                     style="color: darkblue">توضیحات : </span>
                            <p class="font-weight-bold py-0 col-md pr-3"
                               v-for="(line) in archives.description.split('\n')"
                               :key="line" v-html="line">
                            </p>
                        </div>


                        <div v-if="archives.reject_text!== null">
                            <p class="pr-3 pt-2"><span class="font-weight-bolder"
                                                       style="color: darkblue">دلیل رد کردن : </span>
                            <p class="font-weight-bold py-0 col-md pr-3"
                               v-for="(line) in archives.reject_text.split('\n')"
                               :key="line" v-html="line">
                            </p>
                        </div>
                    </div>
                    <template v-if="admin">
                        <v-container
                                class="px-0"
                                fluid
                        >
                            <v-radio-group v-model="status">
                                <v-radio
                                        color="indigo"
                                        label="پذیرش درخواست"
                                        value="accept"
                                ></v-radio>
                                <div v-if="status==='accept'">
                                    <template>
                                        <v-sheet
                                                width="100%"
                                        >
                                            <v-switch
                                                    v-model="installment"
                                                    flat
                                                    label="پرداخت قسطی"
                                            ></v-switch>
                                            <div v-if="installment">
                                                <v-row v-if="installment">
                                                    <v-col
                                                            class="text-right"
                                                            cols="12"
                                                            md="6"
                                                    >
                                                        <v-text-field
                                                                outlined
                                                                label="مبلغ کل"
                                                                dense
                                                                v-model="main_price"
                                                                clearable
                                                                type="text"
                                                                suffix="﷼"
                                                                @keypress="allowOnlyNumbers"
                                                                clear-icon="mdi-close-circle"
                                                                prepend-inner-icon="fa fa-pencil-alt"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            class="text-right"
                                                            cols="12"
                                                            md="6"
                                                    >
                                                        <v-text-field
                                                                outlined
                                                                label="تعداد اقساط"
                                                                dense
                                                                v-model="count"
                                                                clearable
                                                                @keypress="allowOnlyNumbers"
                                                                clear-icon="mdi-close-circle"
                                                                prepend-inner-icon="fa fa-pencil-alt"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            class="text-right"
                                                            cols="12"
                                                            md="6"
                                                    >
                                                        <date-picker
                                                                v-model="days"
                                                                multiple
                                                                color="#00acc1"
                                                                label="تاریخ پرداخت"
                                                                input-class="mb-0 rounded"
                                                                persianDigits
                                                                clearable
                                                                :timezone="false"
                                                                format="YYYY-MM-DD"
                                                                style="font-size: 13px!important"
                                                                class="dateSet"
                                                                display-format="jMMMM jD"
                                                        />

                                                    </v-col>
                                                    <v-col class="text-right mb-8"
                                                           cols="12"
                                                           md="12">
                                                        <p class="pb-3">توضییحات قسط</p>
                                                        <V8Editor v-model="Acceptdescription"/>
                                                    </v-col>
                                                    <v-row class="px-5 mb-8">
                                                        <v-col
                                                                v-for="(item,index) in transactions"
                                                                class="text-right"
                                                                cols="12"
                                                                md="6"
                                                        >
                                                            <v-text-field
                                                                    outlined
                                                                    :label="'مبلغ قسط' + Number(index +1)"
                                                                    dense
                                                                    clearable
                                                                    :value="transactions[index].price | currency"
                                                                    @input="priceIs(transactions[index],$event)"
                                                                    @keypress="allowOnlyNumbers"
                                                                    clear-icon="mdi-close-circle"
                                                                    prepend-inner-icon="fa fa-pencil-alt"
                                                            >
                                                                <template v-slot:append>
                                                                    <v-chip
                                                                            close
                                                                            close-icon="mdi-delete"
                                                                            color="indigo"
                                                                            @click:close="removeDay(index)"
                                                                            dense
                                                                            small
                                                                            outlined
                                                                            pill
                                                                    >{{ jalalian(transactions[index].expired_at) }}
                                                                    </v-chip>
                                                                </template>
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                                <div class="text-center">
                                                    <p>مبلغ قابل پرداخت در هر قسط : <span
                                                            class="text-primary">{{
                                                            countPrice|currency|persianNum
                                                        }} ﷼ </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <v-switch
                                                    v-model="final"
                                                    flat
                                                    label="پرداخت بصورت یکجا"
                                            ></v-switch>
                                            <div v-if="final">
                                                <v-row v-if="final">
                                                    <v-col
                                                            class="text-right"
                                                            cols="12"
                                                            md="6"
                                                    >
                                                        <v-text-field
                                                                outlined
                                                                label="مبلغ کل"
                                                                dense
                                                                v-model="main_price"
                                                                clearable
                                                                suffix="﷼"
                                                                @keypress="allowOnlyNumbers"
                                                                clear-icon="mdi-close-circle"
                                                                prepend-inner-icon="fa fa-pencil-alt"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col class="text-right mb-8"
                                                           cols="12"
                                                           md="12">
                                                        <p class="pb-3">توضییحات قسط</p>
                                                        <V8Editor v-model="Acceptdescription"/>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-sheet>
                                    </template>
                                </div>
                                <v-radio
                                        color="indigo"
                                        label="ردکردن درخواست"
                                        value="reject"
                                ></v-radio>
                                <div v-if="status==='reject'">
                                    <v-col class="text-right mb-8"
                                           cols="12"
                                           md="12">
                                        <p class="pb-3">دلیل ردکردن </p>
                                        <V8Editor v-model="Rejectdescription"/>
                                    </v-col>
                                </div>
                            </v-radio-group>
                        </v-container>
                    </template>
                    <div v-if="admin" class="float-left">

                        <v-btn :loading="loading" v-if="installment" @click="payInstallment" class="submit-btn">
                            <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
                            ثبت درخواست
                        </v-btn>

                        <v-btn :loading="loading" v-if="final" @click="payFinal" class="submit-btn">
                            <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
                            ثبت درخواست
                        </v-btn>
                        <v-btn :loading="loading" v-if="status==='reject'" @click="reject" class="submit-btn">
                            <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
                            ثبت درخواست
                        </v-btn>

                    </div>
                    <div v-if="admin && archives.payments !==null">
                        <p>ارسال فایل برای کاربر</p>
                        <sen-sample :type="archives.type" :form-id="archives.payments.form_id"></sen-sample>
                    </div>
                    <div class="row mx-auto" v-if="archives.hasOwnProperty('files') && archives.files!= null">
                        <div class="col-md-4 px-0" v-if="!admin"
                             v-for="(item,index) in archives.files.files">
                            <a target="_blank"
                               :href="imageFiles(item)"
                               download=""
                               class=" btn-download"
                            >
                                <i style="font-size: 12pt" class="material-icons">file_download</i>
                                {{ 'دانلود فایل نمونه ' + (index + 1) }}
                            </a>
                        </div>
                    </div>
                    <div class="row mx-auto" v-if="archives.files!= null">
                        <div class="col-md-4 px-0 "
                             v-if="!admin && archives.files!==null && archives.files.hasOwnProperty('sampleFiles')"
                             v-for="(item,index) in archives.files.sampleFiles">
                            <a
                                    :href="imageFiles(item)"
                                    target="_blank"
                                    class="btn-download"
                                    download="">
                                <i style="font-size: 13pt" class="material-icons">file_download</i>
                                {{ 'دانلود فایل نهایی ' + (index + 1) }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 py-10 mx-auto" v-else>
            <p class="text-center">در حال بارگیری اطلاعات</p>
            <v-progress-linear
                    indeterminate
                    height="5"
                    striped
                    color="indigo"
            ></v-progress-linear>
        </div>
    </div>
</template>

<script>
import SenSample from "../site/senSample";

export default {
    name: "setInformations",
    components: {SenSample},
    props: {
        id: {
            default: ''
        },
        url: {
            default: 'form/graphic/tracet'
        },
        admin: {
            default: true
        },
        modal: {
            default: () => {
            },
            type: Function
        },
        reqAgain: {
            default: () => {
            },
            type: Function
        },
        archives: {
            default: {}
        },
    },
    data() {
        return {
            transactions: [],
            language: {
                'persian': 'فارسی',
                'english': 'انگلیسی',
                'both': 'فارسی+انگلیسی',
            },
            folder: {
                'A4Pocket': 'جیب-دار',
                'A4PocketWavy': 'جیب دار طرح موج A4',
                'A4Lock': 'قفل دار A4',
            },
            directions: {
                'right': ' ازراست(فارسی)',
                'left': 'ازچپ(انگلیسی)',
                'up': 'از بالا',
            },
            noteMaterial: {
                'plastics': 'پلاستیکی',
                'cardBoard': 'مقوایی',
                'cloth ': 'پارچه ای',
                'leather ': 'چرمی',
            },
            letterMaterial: {
                'graft': 'گرافت',
                'cotton': 'کتان',
                'writing': 'تحریر',
                'gloss': 'گلاسه',
                'cards': 'کارتی',
            },
            folderMaterial: {
                'leather': 'چرمی',
                'cotton': 'کتان',
                'writing': 'تحریر',
            },
            orderType: {
                'design': 'فقط طراحی',
                'designPrint': 'طراحی به همراه چاپ',
            },
            printType: {
                'design': 'فقط طراحی',
                'designPrint': 'طراحی به همراه چاپ',
            },
            designStyle: {
                'oneSide': 'تراکت-یک-رو',
                'twoSide': ' تراکت-دورو',
            },
            headerSize: {
                'A3': 'A3',
                'A4': 'A4',
                'A5': 'A5',
                'A6': 'A6',
                'B5': 'B5',
            },
            sabks: {
                'classic': 'کلاسیک',
                'luxury': 'لوکس',
                'simple': 'ساده',
                'innovative': 'خلاق',
                'unusual': 'فانتزی',
                'public': 'عمومی',
                'modern': 'مدرن',
            },
            complexitive: {
                'abstract': 'انتزاعی',
                'complex': 'پیچیده',
                'sharpCorner': 'گوشه تیز',
                'roundCorner': 'گوشه نرم و لطیف',
                'designerChose': 'به انتخاب طراح',
            },
            cardMaterial: {
               'shinyCellphane': 'کارت ویزیت سلفون براق',
               'shinyLaminate': '   کارت ویزیت لمینت براق',
               'matteLaminate': '  کارت ویزیت لمینت مات',
               'uvGlasse': ' کارت ویزیت گلاسه یو وی',
               'germanCotton': 'کارت ویزیت کتان آلمان',
               'plasticCotton': ' کارت ویزیت کتان پلاستیک',
               'highlightGold': '  کارت ویزیت لمینت برجسته طلاکوب',
               'velvetyHighlight': 'کارت ویزیت لمینت مخملی برجسته',
               'glassy': 'کارت ویزیت شیشه ایی',
               'highlightMatteCellphane': '  کارت ویزیت سلفون مات برجسته',
               'highlightvelvetyCellphane': '  کارت ویزیت سلفون مخملی',
               'velvetyCellphane': '   کارت ویزیت سلفون مخملی برجسته',
               'goldvelvetyCellphane': 'کارت ویزیت سلفون مخملی طلاکوب',
               'pvc': '  کارت ویزیت پی وی سی',
               'pvc760Micron': ' کارت ویزیت پی وی سی760 میکرون متالیک',
               'pvc760metalic': ' کارت ویزیت پی‌وی‌سی 760 متالیک',
               'magnet': '  کارت ویزیت آهنربایی',
            },
            noteType: {
                'button': 'دکمه ای',
                'buffer': 'فنرزنی',
                'press': 'پرسی',
                'band': 'کشی',
                'sticky': 'چسبی',
            },
            diagram: {
                'circle': 'دایره',
                'square': 'مربع',
                'horizontalTriangle': 'مستطیل-افقی',
                'verticalTriangle': 'مستطیل-عمودی',
            },
            shape: {
                'horizontalTriangle': 'مستطیل-افقی',
                'verticalTriangle': 'مستطیل-عمودی',
            },
            loading: false,
            status: 'accept',
            Acceptdescription: '',
            installment: false,
            final: false,
            mainPrice: '',
            Rejectdescription: '',
            finalPrice: '',
            days: [],
            description: '',
            count: ''
        }
    },
    methods: {
        getArchives() {
            this.loading = true
            this.requestApiGet(this.url + '/' + this.id).then((response) => {
                this.loading = false
                if (this.admin)
                    this.archives = response.data.data;
                else this.archives = response.data

            });
        },
        payFinal() {
            this.requestApiPost('admin/form/officeSet', {
                type: 'final',
                id: this.id,
                name: this.archives.name,
                description: this.Acceptdescription !== '' ? this.Acceptdescription : 'پرداخت بصورت یکجا',
                status: 'accept',
                price: this.mainPrice
            }).then(() => {
                this.$toast.success('درخواست شما با موفقیت ثبت شد.');
                this.modal();
                this.reqAgain();
            })
        },
        priceIs(transaction, value) {
            this.transactions[this.transactions.indexOf(transaction)].price = Number(value.replaceAll(",", ""));
        },
        reject() {
            this.requestApiPost('admin/form/officeSet', {
                type: 'final',
                id: this.id,
                name: this.archives.name,
                status: 'reject',
                reject_text: this.Rejectdescription,
            }).then(() => {
                this.$toast.success('درخواست شما با موفقیت ثبت شد.');
                this.modal();
                this.reqAgain();
            })
        },
        payInstallment() {
            let sum = 0;
            this.transactions.forEach((item) => {
                sum += Number(item.price);
            });

            if (sum > this.mainPrice) {
                this.$toast.error('مبلغ اقساط وارد شده بیشتر از مبلغ کل می باشد!');

            } else if (sum < this.mainPrice) {
                this.$toast.error('مبلغ اقساط وارد شده کمتر از مبلغ کل می باشد!');

            } else {
                this.loading = true;
                this.requestApiPost('admin/form/officeSet', {
                    type: 'installment',
                    id: this.id,
                    name: this.archives.name,
                    description: this.Acceptdescription !== '' ? this.Acceptdescription : '',
                    expired_at: '',
                    status: 'accept',
                    price: this.mainPrice,
                    transactions: this.transactions

                }).then(() => {
                    this.loading = false;
                    this.$toast.success('درخواست شما با موفقیت ثبت شد.');
                    this.modal();
                    this.reqAgain();
                }).catch(() => {
                    this.loading = false;
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        removeDay(id) {
            this.days.splice(id, 1)
        },
        imageFiles(img) {
            return process.env.VUE_APP_API_URL + '/storage/' + img
        },
    },
    beforeMount() {
        if (Object.entries(this.archives).length <= 0)
            this.getArchives();
    },
    watch: {
        installment(val) {
            if (val) {
                this.final = false;
            } else {
                this.mainPrice = '';
                this.count = '';
                this.Acceptdescription = '';
                this.days = [];
            }
        },
        final(val) {
            if (val)
                this.installment = false
        },
        status(val) {
            if (val === 'accept')
                this.description = '';
        },
        days(val) {
            this.count = val.length;
            this.transactions = [];
            val.forEach((item, index) => {
                this.transactions.push({
                    description: 'قسط' + ' ' + Number(index + 1),
                    price: '',
                    expired_at: item
                },)
            });
        },
        finalPrice(val) {
            this.transactions = [];
            this.days.forEach((item, index) => {
                this.transactions.push({
                    description: 'قسط' + ' ' + Number(index + 1),
                    price: '',
                    expired_at: item
                },)
            });
        }
    },
    computed: {
        main_price: {
            get() {
                return this.$options.filters.currency(this.mainPrice)
            },
            set(value) {
                this.mainPrice = value.replaceAll(',', '')
            }
        },
        countPrice() {
            return this.finalPrice = this.mainPrice / this.count
        },
    },
}
</script>

<style>

</style>